import {
    UPDATE_LOOKER_FRAME,
    UPDATE_LOOKER_TABS_VISITED,
    SET_LOOKER_FRAME,
    SET_LOOKER_TYPE,
} from '../actions/lookerActions';

const updateLookerFrameReducer = (state = {}, { type, updatedUrl }) => {
    switch (type) {
        case UPDATE_LOOKER_FRAME:
            return { ...state, updatedUrl };
        default:
            return state;
    }
};

const updateLookerTabsVisitedReducer = (state = {}, { type, updatedTab }) => {
    switch (type) {
        case UPDATE_LOOKER_TABS_VISITED:
            return { ...state, ...updatedTab };
        default:
            return state;
    }
};

const setAnalyticsLookerReducer = (state = {}, { type, setUrl }) => {
    switch (type) {
        case SET_LOOKER_FRAME:
            return { ...state, setUrl };
        default:
            return state;
    }
};

const setRiskTypeReducer = (state = {}, { type, setType }) => {
    switch (type) {
        case SET_LOOKER_TYPE:
            return { ...state, setType };
        default:
            return state;
    }
};

export { updateLookerFrameReducer, updateLookerTabsVisitedReducer, setAnalyticsLookerReducer, setRiskTypeReducer };
